import scheduledEventsComponent from './scheduledEvents.component';

const scheduledEventsModule = angular.module('app.components.clinicalData.scheduledEvents', [])
	  .component('scheduledEvents', scheduledEventsComponent)
	.name;

export default scheduledEventsModule;
